/**
 * findJobNodeByJobReferenceId.js — historia 170 (Repositorio Documental), J4a (S90). Pure lookup: the
 * workflow editor (`Workflow.jsx`) receives `initialJobReferenceId` from `MainWorkflows.jsx`
 * (`state.jobReferenceId`) and needs the JOB node whose `jobReference.id` matches it, to select it
 * the same way a real click would (`dispatchWorkflowData({ type: 'SET_CURRENT_NODE', node })`).
 * Extracted so it is unit-testable without mounting the full editor.
 *
 * Returns `{}` (never `null`/`undefined`, CLAUDE.md) when nothing matches — the caller treats it as
 * falsy either way (`initialSelectedJobNode ? {...} : {}`, `Workflow.jsx`), so this is a plain
 * substitution, not a behaviour change.
 */
export const findJobNodeByJobReferenceId = (nodes, jobReferenceId) => {
  if (!jobReferenceId || !nodes) return {}
  return nodes.find((node) => node.nodeType === 'JOB' && node.jobReference && node.jobReference.id === jobReferenceId) || {}
}

/**
 * toInitialCurrentNodeState(jobNode) — historia 170 (J4a, corrección CLAUDE.md).
 * `findJobNodeByJobReferenceId` returns `{}` (never `null`/`undefined`) when nothing matched, and an
 * empty object is truthy in JS: a plain `jobNode ? { currentNode: jobNode } : {}` ternary on its
 * result would wrongly seed `currentNode: {}` on every "not found"/absent case. Checks for a real
 * match (`.id` present — every JOB node has one) instead.
 */
export const toInitialCurrentNodeState = (jobNode) => (jobNode.id ? { currentNode: jobNode } : {})
